import { CheckoutContainerProps } from '../..';
import Drawer from '@/components/templates/Drawer';
import * as S from './styles';
import Text from '@/components/atoms/Text';
import formatarMoeda from '@/utils/formatarMoeda';
import IconButton from '@/components/atoms/IconButton';
import { IconeCarrinho } from '@/components/atoms/Icones/IconeCarrinho';
import Button from '@/components/atoms/Button';

export default function CheckoutContainerMobile(props: CheckoutContainerProps) {
  const {
    $valorTotal,
    $funcaoAdicionarAoCarrinho,
    $funcaoAcaoPrincial,
    $textoBotaoAcaoPrincipal,
    $permitirUsuarioRealizarCompra,
  } = props;

  return (
    <Drawer>
      <S.Container>
        <S.ContainerDetalhamentoValores>
          <Text
            $size={3}
            $color="neutral"
            $weight="medium"
            $align="left"
            $highContrast={false}
            $text={'Subtotal'}
            $quebraTexto={false}
          />
          <Text
            $size={4}
            $color="neutral"
            $weight="bold"
            $align="left"
            $highContrast={true}
            $text={formatarMoeda({
              valor: $valorTotal,
            })}
            $quebraTexto={false}
          />
        </S.ContainerDetalhamentoValores>
        <S.ContainerLinhaBotoes>
          {$permitirUsuarioRealizarCompra ? (
            <div>
              <IconButton
                $Icon={IconeCarrinho}
                $size={1}
                $state="default"
                $variant="soft"
                $color="accent"
                $highContrast={false}
                $loading={false}
                $focusRing={false}
                $onClick={$funcaoAdicionarAoCarrinho}
                style={{ justifyContent: 'center', padding: 10 }}
              />
            </div>
          ) : null}
          <Button
            style={{ justifyContent: 'center', flex: 1 }}
            $size={2}
            $variant="solid"
            $color="accent"
            $highContrast={false}
            $loading={false}
            $focusRing={false}
            $disable={!$permitirUsuarioRealizarCompra}
            $text={$textoBotaoAcaoPrincipal}
            $onClick={$funcaoAcaoPrincial}
          />
        </S.ContainerLinhaBotoes>
      </S.Container>
    </Drawer>
  );
}
